import { GarudaResponse } from "../../models/events";
import { useAppDispatch } from "../../../../../common/state/hooks";
import {  GadgetInstallationProgressBody, InstallationStatus } from "../../models/body";
import { update } from "../../../../../common/state/Slices/InstalledGadgetsSlice";

export const useGadgetInstallationProgressHandler = () => {
    const dispatch = useAppDispatch();

    const handleGadgetInstallationProgress = (response: GarudaResponse) => {
        const body = response.body as GadgetInstallationProgressBody;
        dispatch(
            update(
                {
                    sourceDeviceId: body.sourceDeviceId,
                    gadgetId: body.gadgetId,
                    status: InstallationStatus.INSTALLING,
                    progress: body.progress
                }
            )
        );
    };

    return {
        handleGadgetInstallationProgress
    }
}